import React from 'react'
import PropTypes from 'prop-types'
import css from './MetricBox.module.scss'
import Label from '../Label/Label.jsx'
import {colors} from '../../utils/colors.js'
import {formatPercentage} from '../../utils/formatPercentage.js'

const VARIANT_COLORS = {
  success: 'var(--success)',
  danger: 'var(--danger)',
  warning: 'var(--warning)',
  info: 'var(--info)',
  accent: 'var(--accent)',
};

const formatPercentageValue = (percentageValue) => {
  if (typeof percentageValue === 'number') {
    return formatPercentage(percentageValue);
  }
  if (typeof percentageValue !== 'string') {
    return null;
  }
  const trimmedValue = percentageValue.trim();

  return trimmedValue === '' ? null : trimmedValue;
};

const MetricBox = ({
  title,
  icon,
  className,
  style,
  bgColor, 
  fontColor,
  variant,
  value,
  percentageValue,
  layout = 'inline',
}) => {
  const isStacked = layout === 'stacked';
  const variantClass = variant ? css[variant] : '';
  const customStyles = !variant ? {backgroundColor: bgColor, color: fontColor} : {};
  const mergedStyles = {...customStyles, ...style};
  const valueColor = variant ? VARIANT_COLORS[variant] : 'var(--primary-color)';
  const formattedPercentageValue = formatPercentageValue(percentageValue);

  return (
    <div
      className={`${css.metricBox} ${isStacked ? css.stacked : css.inline} ${variantClass} ${className || ''}`}
      style={mergedStyles}
    >
      <div className={css.header}>
        {icon && <span className={css.icon} style={{color: valueColor}}>{icon}</span>}
        <span className={css.title}>{title}</span>
      </div>
      <div className={css.valueRow}>
        <span className={css.value} style={isStacked ? {color: valueColor} : undefined}>{value}</span>
        {formattedPercentageValue &&
          <Label size="md" color={colors.grey64} backgroundColor={colors.white}>
            {formattedPercentageValue}
          </Label>
        }
      </div>
    </div>
  )
}

MetricBox.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'info', 'accent']),
  percentageValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  layout: PropTypes.oneOf(['inline', 'stacked']),
}

export default MetricBox;
